import type { App } from 'vue'
import { auth } from '@/utils/auth'
import { vCopy } from '@/utils/clipboard'

export function setupDirectives(app: App) {
  // 注册 v-auth 指令
  app.directive('auth', auth)
  // 注册 v-copy 指令
  app.directive('copy', vCopy)
}
